export default {slug_name:'hosting_connector',type:'connector',version:'0.0.1',author:'Answer'};